import React from "react"

const Image = props => {
    return (
        <picture>
            {props.breakpoints ? props.breakpoints.map((data, index) => (
                <React.Fragment key={index}>
                    {data.srcWebp ? <source srcSet={data.srcWebp} media={`(max-width: ${data.maxWidth}px)`} type="image/webp" /> : null}
                    {data.src ? <source srcSet={data.src} media={`(max-width: ${data.maxWidth}px)`} /> : null}
                </React.Fragment>
            )) : null}

            {props.srcWebp ? <source srcSet={props.srcWebp} type="image/webp" /> : null}
            {props.src ? <source srcSet={props.src} /> : null}

            <img
                src={props.src}
                alt={props.alt}
                className={props.className}
            />
        </picture>
    )
}

export default Image